/* global theme */

(() => {
	const TRACKING_SELECTOR = '[data-contest-cart-tracking]';
	let activeRequest = null;

	const syncTracking = async () => {
		const trackingNode = document.querySelector(TRACKING_SELECTOR);
		if (!trackingNode || trackingNode.dataset.shouldSync !== 'true') return;
		if (!theme || !theme.routes || !theme.routes.cartUpdate) return;
		if (activeRequest) return;

		activeRequest = fetch(theme.routes.cartUpdate, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				attributes: {
					contest_campaign: trackingNode.dataset.campaignKey || '',
					contest_entries: trackingNode.dataset.entries || '',
					contest_cart_total_cents: trackingNode.dataset.cartTotalCents || '',
					contest_tracking_source: trackingNode.dataset.trackingSource || ''
				}
			})
		});

		try {
			await activeRequest;
			trackingNode.dataset.shouldSync = 'false';
		} catch (error) {
			console.log(error);
		} finally {
			activeRequest = null;
		}
	};

	document.addEventListener('DOMContentLoaded', syncTracking);
	document.addEventListener('on:line-item:change', syncTracking);
	document.addEventListener('dispatch:cart-drawer:refresh', syncTracking);
})();
